module.exports = __webpack_public_path__ + "static/media/mbl_menu.6b32f14d.svg";